import React, { useEffect, useRef, useId } from 'react';

export default function PlannerDialog({ title, onClose, children, wide = false }) {
  const ref = useRef(null), titleId = useId();
  useEffect(() => {
    const previous = document.activeElement;
    ref.current.showModal();
    return () => { if (previous?.isConnected) previous.focus(); };
  }, []);
  const keepFocusInDialog = event => {
    if (event.key !== 'Tab') return;
    const controls = [...ref.current.querySelectorAll('button, input, select, textarea, a[href], [tabindex]')]
      .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  };
  return <dialog ref={ref} className={`planner-dialog ${wide ? 'planner-dialog-wide' : ''}`} aria-labelledby={titleId}
    onKeyDown={keepFocusInDialog} onCancel={event => { event.preventDefault(); onClose(); }}>
    <header><h2 id={titleId}>{title}</h2><button type="button" aria-label={`Close ${title}`} onClick={onClose}>✕</button></header>
    <div className="planner-dialog-content">{children}</div>
  </dialog>;
}
